// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-settings-container {
  height: 100vh;
  background-size: cover;
  height: 100vh;
  font-family: "Inter";
  color: black;
  gap: 5rem;
  display: flex;
  flex-direction: column;
  gap: 4rem;
  align-items: center;
}

.delete-account {
  color: #5a5a5a;
  background-color: #d9dadd;
  border: none;
  border-radius: 50rem;
  padding: 0.4rem;
  font-size: 1.4rem;
  width: 15rem;
}

.delete-account:hover {
  color: black;
  cursor: pointer;
  font-family: "Quicksand", sans-serif;
  box-shadow: 0 0 3.2rem rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out;
  transform: scale(1.05);
}

.account-box {
  color: black;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  justify-content: flex-start;
  align-items: flex-start;
  width: 40rem;
  font-size: 1.4rem;
  display: flex;
  margin: 2rem;
  padding: 1.5rem;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  background-color: #e5e7ebe2;
  display: flex;
  gap: 2rem;
}

.my-account-info {
  display: inline-block;
  text-align: center;
  font-size: 1.4rem;
  text-transform: uppercase;
}

.account-input,
.account-input-password {
  background-color: white;
  border: none;
  border-radius: 100rem;
  padding: 0.4rem;
  padding-left: 1rem;
  margin-left: 1rem;
  font-size: 1.4rem;
  width: 20rem;
}

.account-email {
  margin-left: 1rem;
}

.my-account-info-email {
  font-size: 1.4rem;
}

.my-account-info-password {
  font-size: 1.4rem;
}

.settings-account-btns {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

@media (max-width: 460px) {
  .my-account-info {
    font-size: 1.2rem;
  }
  .my-account-info-email {
    font-size: 1.2rem;
    align-self: center;
  }
  .my-account-info-password {
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .account-box {
    width: 25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/VendorSettings/VendorSettings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,yCAAyC;EACzC,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,wCAAwC;EACxC,2BAA2B;EAC3B,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".customer-settings-container {\n  height: 100vh;\n  background-size: cover;\n  height: 100vh;\n  font-family: \"Inter\";\n  color: black;\n  gap: 5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 4rem;\n  align-items: center;\n}\n\n.delete-account {\n  color: #5a5a5a;\n  background-color: #d9dadd;\n  border: none;\n  border-radius: 50rem;\n  padding: 0.4rem;\n  font-size: 1.4rem;\n  width: 15rem;\n}\n\n.delete-account:hover {\n  color: black;\n  cursor: pointer;\n  font-family: \"Quicksand\", sans-serif;\n  box-shadow: 0 0 3.2rem rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease-in-out;\n  transform: scale(1.05);\n}\n\n.account-box {\n  color: black;\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 40rem;\n  font-size: 1.4rem;\n  display: flex;\n  margin: 2rem;\n  padding: 1.5rem;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  background-color: #e5e7ebe2;\n  display: flex;\n  gap: 2rem;\n}\n\n.my-account-info {\n  display: inline-block;\n  text-align: center;\n  font-size: 1.4rem;\n  text-transform: uppercase;\n}\n\n.account-input,\n.account-input-password {\n  background-color: white;\n  border: none;\n  border-radius: 100rem;\n  padding: 0.4rem;\n  padding-left: 1rem;\n  margin-left: 1rem;\n  font-size: 1.4rem;\n  width: 20rem;\n}\n\n.account-email {\n  margin-left: 1rem;\n}\n\n.my-account-info-email {\n  font-size: 1.4rem;\n}\n\n.my-account-info-password {\n  font-size: 1.4rem;\n}\n\n.settings-account-btns {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n@media (max-width: 460px) {\n  .my-account-info {\n    font-size: 1.2rem;\n  }\n  .my-account-info-email {\n    font-size: 1.2rem;\n    align-self: center;\n  }\n  .my-account-info-password {\n    font-size: 1.2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n  .account-box {\n    width: 25rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
